"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _GridUtils = require("./GridUtils.js");

var _styled = require("./styled.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var Col = function Col(_ref) {
  var children = _ref.children,
      width = _ref.width,
      last = _ref.last,
      className = _ref.className,
      centered = _ref.centered;
  return _react["default"].createElement(_styled.StyledCol, {
    width: width,
    last: last,
    className: "".concat(className || '', " ").concat(centered ? 'contentCentered' : '')
  }, (0, _GridUtils.classifier)(children));
};

Col.defaultProps = {
  _name: 'Col',
  weight: 1
};
var _default = Col;
exports["default"] = _default;

//# sourceMappingURL=Col.js.map